'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { StatusWarningFilled, StatusCheckCircleFilled } from '@s7/icons';

const InputIcon = ({ state })=>{
    switch(state){
        case 'default':
            return null;
        case 'success':
            return /*#__PURE__*/ jsx(StatusCheckCircleFilled, {
                color: "primary.base"
            });
        case 'error':
            return /*#__PURE__*/ jsx(StatusWarningFilled, {
                color: "disruption.mid"
            });
        default:
            return null;
    }
};
InputIcon.displayName = 'InputIcon';

export { InputIcon };
//# sourceMappingURL=InputIcon.js.map
